export default{
    state:{       
        establecimiento:{
            nombrecomercial:'COMERCIAL Y SERVICIOS NAZARETH',
            codigo:'1',
            propietario:'ALFECORP, SOCIEDAD ANÓNIMA',
            nit:'111004756',
            direccion:'CALLE TRANSITO ROJAS Zona 5, BARRIO SAN FRANCISCO 4-39, JALAPA',
            codigopostal:'21001',
            municipio:'JALAPA',
            departamento:'GUATEMALA',
            codregimen:'GEN' //COMERCIO
        },
        // establecimiento:{
        //     nombrecomercial:'PEST.CONTROL',
        //     codigo:'1',
        //     propietario:'Allan Bonilla',
        //     nit:'44653948',
        //     direccion:'6A. CALLE 1-30 Zona 2, BARRIO LA ESPERANZA , Jalapa',
        //     codigopostal:'0101',
        //     municipio:'GUATEMALA',
        //     departamento:'GUATEMALA',
        //     codregimen:'GEN'
        // }
        
    },
    getters:{
        getEstablecimiento(state){
            return state.establecimiento
        }
    }
}